<template>
  <!-- 我的优惠券详情页面 -->
  <div class="couponDetail">
    <!-- <section class="couponInfoBox"> -->
    <div v-if="isShowQR">
      <div class="showQR fhcud">
        <!-- <div class="disabled fc" v-if="isDisable">
          <img :src="disableImgUrl" alt="" />
        </div> -->
        <!-- <div v-show="!isDisable" id="qrcode" class="fc"></div> -->
        <div class="couponCode">券码 {{ datas.couponCode }}</div>
        <div class="time">有效期：{{ getTime(datas) }}</div>
        <div>请联系店内服务顾问协助使用</div>
      </div>
    </div>
    <div class="coupon" v-if="isShowCoupon">
      <!-- 优惠券信息 -->
      <div class="couponBox">
        <couponCard class="couponCard" :disable="isDisable" :isMy="true" :datas="datas" :isDetail="true"> </couponCard>
      </div>
    </div>

    <!-- 经销商 -->
    <div class="dealerInfoBox">
      <div v-if="distributeTypeFlag === 1">
        <p class="newColLabel">适用经销商</p>
        <div class="dealerLocationBox">
          <p class="dealerLocation">
            {{ datas.dealerInfo.name }}
          </p>
          <a :href="`tel:${datas.dealerInfo.tel}`">
            <van-icon class="phone" name="phone" />
          </a>
        </div>
      </div>
      <CurrentDealer v-if="distributeTypeFlag === 2" :isShowPhone="isShowPhone">
        <template #colLabel><span class="newColLabel">浏览经销商</span></template>
        <template #noDealer><span></span> </template>
        <template #currentDealer> <span></span></template>
        <template #afterName> <span></span></template>
      </CurrentDealer>
    </div>
    <!-- </section> -->

    <section class="cellBox">
      <!-- 描述说明信息 -->
      <van-collapse v-model="discrptionuseCollapse">
        <van-collapse-item title="优惠券描述" name="1">
          <div class="accordionContent" v-html="datas.description || '暂无优惠券描述'"></div>
        </van-collapse-item>
      </van-collapse>
      <van-collapse v-model="useCollapse">
        <van-collapse-item title="使用限制说明" name="1">
          <div class="accordionContent" v-html="datas.useDescription || '暂无使用限制说明'"></div>
        </van-collapse-item>
      </van-collapse>
    </section>
    <!-- 底部按钮 -->
    <section class="bottomWrap" v-if="bottomBtnData.text">
      <couponBtn :data="[bottomBtnData]" @click="clickBtn($event, datas)"> </couponBtn>
    </section>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import { getMyCouponDetail } from '@/api/couponCollection'
import couponCard from '@/components/couponCollection/CouponCard'
import couponBtn from '@/components/order/BottomBtn'
import { showToast, reorganizeListData } from '@/util/couponCollection'
import QRCode from 'qrcodejs2'
export default {
  name: 'planDetail',
  components: { CurrentDealer, couponBtn, couponCard },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    let { from, couponId } = route.query
    const state = reactive({
      from,
      couponId,
      datas: {},
      bottomBtnData: {},
      discrptionuseCollapse: ['1'],
      useCollapse: ['1'],
      isDisable: true,
      isShowQR: false,
      isShowPhone: true,
      isShowCoupon: false,
      disableImgUrl: '',
      distributeTypeFlag: 0, // 发放方式标识{1：按经销商发放 2：厂家直接发放}
      usedTypeFlag: 0 //核销类型{1：订单核销 2：快速核销 3：商城使用（轮胎）4:不核销 5:OTR+核销}
    })

    // 获取优惠券详情信息
    const getCouponDetailFn = async () => {
      try {
        let data = await getMyCouponDetail({
          customerCouponId: state.couponId
        })
        let temp = reorganizeListData([data])
        data = temp[0] || {}
        state.datas = data
        state.distributeTypeFlag = data.distributeTypeFlag
        state.usedTypeFlag = data.usedTypeFlag
        //statusFlag 1:未生效 2:可使用 3:已过期 4:暂不可用 5.已使用
        state.isDisable = data.statusFlag !== 2

        // 核销型优惠券
        if ([1, 2, 5].includes(data.usedTypeFlag)) {
          state.isShowQR = data.statusFlag === 2
          state.isShowCoupon = true
          state.bottomBtnData = {}
          // makeQrcode()
        }
        // 轮胎惠券
        if (data.usedTypeFlag === 3) {
          state.isShowCoupon = true
          state.isShowQR = false
          if (data.statusFlag === 2) {
            let bottomBtnData = { text: '', type: 'active', size: 'large' }
            // 按经销商发放
            if (data.distributeTypeFlag === 1) {
              bottomBtnData.text = '查看适用产品'
            }
            // 按厂家发放型
            if (data.distributeTypeFlag === 2) {
              bottomBtnData.text = '去使用'
            }
            state.bottomBtnData = bottomBtnData
          }
        }
        // 体验券
        if (data.usedTypeFlag === 4) {
          state.isShowCoupon = true
          state.isShowQR = false
          state.bottomBtnData = {}
        }
      } catch (e) {
        showToast(e.message, '获取详情数据失败')
      }
    }

    // 点击按钮
    let clickBtn = (v, data) => {
      // console.log("--clickBtn-->", v, data);
      if (v.type != 'active') return
      if (data.usedTypeFlag === 3 && data.statusFlag === 2) {
        //可使用 && 轮胎优惠券
        router.push({
          path: '/tyreList',
          query: { couponId: data.rightId, from: 'myCoupon', event: '适用优惠券轮胎列表' }
        })
      }
    }
    // const makeQrcode = () => {
    //   let statusFlag = state.datas.statusFlag
    //   if (!state.isDisable) {
    //     let URL = `?from=coupon&couponCode=${state.datas.couponCode}`
    //     if (state.qrcode) {
    //       state.qrcode.clear()
    //       nextTick(() => {
    //         state.qrcode.makeCode(URL)
    //       })
    //     } else {
    //       nextTick(() => {
    //         state.qrcode = new QRCode('qrcode', {
    //           width: 100,
    //           height: 100,
    //           text: URL, // 二维码地址
    //           colorDark: '#000',
    //           colorLight: '#fff'
    //         })
    //       })
    //     }
    //   } else {
    //     state.disableImgUrl = require(`../../../assets/images/status${statusFlag}.png`)
    //   }
    // }

    let getTime = item => {
      return item.activeStartTime + ' - ' + item.activeEndTime
    }

    onMounted(async () => {
      getCouponDetailFn()
    })
    store.dispatch('setDealerJoinPlanFlag', true)
    return {
      ...toRefs(state),
      getCouponDetailFn,
      clickBtn,
      getTime
    }
  }
}
</script>

<style lang="scss" scoped>
.couponDetail {
  background-color: #fff;
  text-align: left;
  padding-bottom: calc(135px + constant(safe-area-inset-bottom));
  padding-bottom: calc(135px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  .dealerInfoBox {
    border-top: 1px solid #f5f5f5;
    margin: 0 10px;
    padding: 18px 10px 10px;
    background-color: #fff;
  }
}
.couponBox {
  padding: 20px;
}

// 经销商样式
.dealerInfoBox {
  .label {
    font-size: 14px;
    color: #333;
    line-height: 30px;
  }
  .van-divider {
    margin: 8px 0;
  }
  .newColLabel {
    font-weight: 400;
    color: #333;
    font-size: 14px;
  }
}

.dealerLocation {
  display: inline-block;
  margin: 10px 10px 0 0;
  width: calc(100% - 40px);
  font-size: 13px;
  color: #666;
  line-height: 18px;
  vertical-align: middle;
}
.phone {
  font-size: 24px;
  color: #3088c5;
  transform: rotate(-90deg);
  vertical-align: middle;
}
.cellBox {
  padding: 0 10px;
  background: #fff;
  :deep(.van-cell) {
    padding: 10px;
  }
}

.accordionContent {
  width: 100%;
  :deep(p) {
    word-break: break-all;
  }
}
.showQR {
  font-size: 12px;
  color: #333333;
  padding: 30px 0 16px;
  img {
    width: 100px;
    height: 100px;
  }
  .couponCode {
    margin: 10px 0 12px;
    font-weight: bold;
    font-size: 14px;
  }
  .time {
    color: #666666;
    margin-bottom: 6px;
  }
}
#qrcode {
  width: 100px;
  height: 100px;
  padding: 5px;
  box-shadow: 0 0 2px #666666;
}
.disabled {
  width: 100px;
  height: 100px;
  background: url('../../../assets/images/QRbg.png');
  background-size: 100%;
}
.bottomWrap {
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  background-color: #f5f5f5;
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
}
</style>
